/* eslint-disable react/prop-types */
import React from 'react';

/**
 * Report-content inclusion counts (036, Report History only) on the shared au-panel
 * system: how many reports include Alert / Pause / Full Day Graph (the INT 0/1 flags,
 * counted where = 1). These are INDEPENDENT OVERLAPPING tallies — each ≤ Logs; a
 * report may carry several flags, so they need NOT sum to Logs. Text + value.
 *
 * Props: { inclusions:{alert,pause,fullDayGraph}, logs }
 */
const n = (v) => Number(v || 0).toLocaleString();
const pct = (c, logs) => (logs > 0 ? ((c / logs) * 100).toFixed(1) : '0.0');

const ReportInclusionPanel = ({ inclusions = {}, logs = 0 }) => {
  const rows = [
    { key: 'alert', label: 'Alert', value: inclusions.alert || 0 },
    { key: 'pause', label: 'Pause', value: inclusions.pause || 0 },
    { key: 'fullDayGraph', label: 'Full Day Graph', value: inclusions.fullDayGraph || 0 },
  ];
  return (
    <div className="au-panel" data-testid="al-inclusions">
      <div className="au-panel__head">
        <h4 className="au-panel__title">Report contents</h4>
        <span className="au-spacer" />
        <span className="al-panel__total">of {n(logs)} reports</span>
      </div>
      <ul className="al-toplist">
        {rows.map((r) => (
          <li key={r.key} className="al-toprow" data-testid={`al-incl-${r.key}`}>
            <span className="al-toprow__name">{r.label}</span>
            <span className="al-toprow__count tnum">{n(r.value)}</span>
            <span className="al-toprow__pct tnum">{pct(r.value, logs)}%</span>
          </li>
        ))}
      </ul>
      <p className="al-panel__note">Independent counts — a report may include several, so these need not sum to Logs.</p>
    </div>
  );
};

export default ReportInclusionPanel;
